import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setLogoutHandler } from "services/client/logoutNotifier";
import { getPublicPathPrefixes } from "app/routes/routes";

/**
 * Wires the logout notifier (used by interceptors on 401 / refresh failure) to React Router.
 * Must be rendered inside RouterProvider so useNavigate is available.
 * On public routes (no protected/authorized), we do not redirect to login so the page can load without token.
 */
export default function ClientLogoutHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const publicPrefixes = getPublicPathPrefixes();
    setLogoutHandler((reason) => {
      const pathname = window.location?.pathname || "";
      if (publicPrefixes.some((prefix) => pathname.startsWith(prefix))) {
        return;
      }
      navigate("/login", { state: reason || {} });
    });
  }, [navigate]);

  return null;
}
